// extracted by mini-css-extract-plugin
export default {"wrapper":"CarouselWrapper_wrapper__9lk6r","title":"CarouselWrapper_title__xikU2"};